/**
 * @generated SignedSource<<3fcd7ef3878ad22a5fab811816c72b1d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutRelayAction_preCheckoutTransaction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"checkoutPaymentReducer_preCheckoutTransaction" | "checkoutShippingReducer_preCheckoutTransaction" | "checkoutTransactionReducer_preCheckoutTransaction">;
  readonly " $fragmentType": "checkoutRelayAction_preCheckoutTransaction";
};
export type checkoutRelayAction_preCheckoutTransaction$key = {
  readonly " $data"?: checkoutRelayAction_preCheckoutTransaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutRelayAction_preCheckoutTransaction">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutRelayAction_preCheckoutTransaction"
};

(node as any).hash = "ac621ae1595c4c532fe34441d7805ec1";

export default node;
